<template>
    <layout-main>
        <div class="container">
            <div class="box mt-4">
                <h2>Min profil</h2>
                <p class="text-secondary">Alle notifikationer og påmindelser bliver sendt til nedenstående e-mail adresse.</p>
                <div class="form-group">
                    <div class="row">
                        <div class="col-lg-3">
                            <label>E-mail</label>
                            <input type="text" class="form-control" v-bind:value="this.$auth.user().email" disabled>
                        </div>	
                    </div>
                </div>
                <hr>

                <h2>Elevdata</h2>
                <p class="text-secondary">Hold din kørelærer opdateret med din aktuelle adresse.</p>
                <AccountEdit></AccountEdit>
                <hr>

                <h2>Skift adgangskode</h2>
                <AccountChangePassword></AccountChangePassword>
            </div>
        </div>
    </layout-main>
</template>

<script>
import LayoutMain from '@/views/layouts/Main.vue';
import AccountEdit from '@/components/account/Edit.vue';
import AccountChangePassword from '@/components/account/ChangePassword.vue';

export default {
    components: {
        LayoutMain, AccountEdit,
        AccountChangePassword,
    },
    methods: {
        updateStudent() {
            this.$store.dispatch('getStudent');
        }
    }
}
</script>
